import * as stylex from '@stylexjs/stylex';
import { borderRadius, color } from '@figma/fpl-tokens/tokens.stylex';

export const styles = stylex.create({
  mediaTile: {
    width: 64,
    height: 64,
    boxSizing: 'border-box',
    borderRadius: borderRadius.medium,
    flexShrink: 0,
  },
  mediaAdd: {
    border: `1px dashed ${color.border}`,
    justifyContent: 'center',
    cursor: 'pointer',
    '--fpl-icon-color': color.iconSecondary,
    backgroundColor: { default: color.bg, ':hover': color.bgHover },
    outline: { default: null, ':focus-visible': `2px solid ${color.borderSelected}` },
    outlineOffset: 1,
  },
  mediaThumbnail: {
    position: 'relative',
    overflow: 'hidden',
    border: `1px solid ${color.border}`,
    '--media-iterator-remove-opacity': { default: 0, ':hover': 1, ':focus-within': 1 },
  },
  mediaImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  },
  mediaRemove: {
    position: 'absolute',
    top: 2,
    right: 2,
    borderRadius: borderRadius.medium,
    backgroundColor: color.bg,
    opacity: 'var(--media-iterator-remove-opacity)',
  },
});
